<app-dialog-container
  [title]="'Module.Option.App.MobileTAN'"
  (closeDialogClicked)="close()"
  [subtitle]="'Module.Option.MobileTan.Subheader' | transloco"
>
  <div class="max-w-3xl mx-auto flex flex-col gap-4">
    <div class="bg-white rounded-xl shadow-lg p-8 text-center">
      @if (tan) {
        <div class="flex flex-col items-center gap-2">
          <div class="text-base text-primary-accumin-purple-100 font-medium mb-2">
            {{ "Module.Option.App.ScanningQR" | transloco }}
          </div>
          <div class="bg-gray-50 rounded-xl shadow-sm">
            <qrcode [qrdata]="tan" [width]="150" />
            <div class="font-mono text-lg text-accumin-berry-100 font-medium bg-accumin-sky-100 px-4 py-2 rounded-lg inline-block">
              {{ "Module.Option.MobileTan.Tan" | transloco | uppercase }} {{ tan }}
            </div>
          </div>
          <div class="text-center p-5 w-full max-w-[300px]">
            <div class="text-sm text-accumin-berry-100">
              {{ "Module.Option.App.QRTimer" | transloco: { Time: AuthenticationTime } }}
            </div>
          </div>
        </div>
      }
      @if (hasError) {
        <div class="text-red-500 mt-4">
          {{ "General.UnexpectedError" | transloco }}
        </div>
      }
    </div>

    <div class="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-200 bg-gray-100">
        <h4 class="m-0 text-base font-medium text-gray-600">
          {{ "Module.Option.App.HeaderMobileTAN" | transloco }}
        </h4>
      </div>
      <div class="p-6">
        <div class="flex gap-4 justify-center">
          <a
            href="https://apps.apple.com/de/app/stmate/id1528703603"
            target="_blank"
            class="transition-transform duration-200 hover:scale-105"
          >
            <img [ngSrc]="appleStore" width="120" height="40" alt="Apple-Store" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=de.ongeo.stmate"
            target="_blank"
            class="transition-transform duration-200 hover:scale-105"
          >
            <img [ngSrc]="googlePlayStore" width="120" height="40" alt="GooglePlay-Store" />
          </a>
        </div>
        <ul class="list-disc list-outside text-gray-600 mb-5 mt-2 text-sm">
          <li class="mb-4">{{ "Module.Option.MobileTan.UsageInfo_1" | transloco }}</li>
          <li class="mb-4">{{ "Module.Option.MobileTan.UsageInfo_2" | transloco }}</li>
          <li class="mb-4">{{ "Module.Option.MobileTan.UsageInfo_3" | transloco }}</li>
          <li>{{ "Module.Option.MobileTan.UsageInfo_4" | transloco }}</li>
        </ul>
      </div>
    </div>
  </div>
</app-dialog-container>
